import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestSection from './components/LatestSection';
import NewArrivals from './components/NewArrivals';
import FeaturesSection, { CTASection } from './components/FeaturesSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [location.pathname]);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'yy漫画 - 正版授权漫画平台',
    url: 'https://yytoon.github.io',
    description: 'yy漫画是专注正版授权的在线漫画阅读平台，汇聚热门连载、完结漫画海量资源，涵盖恋爱、热血、悬疑、奇幻等多种类型。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://yytoon.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'yy漫画',
    url: 'https://yytoon.github.io',
    description: '正版授权在线漫画阅读平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      email: 'contact@yymanhua.com',
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '漫画创意产业园A座12层',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'yy漫画是正版授权的漫画平台吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，yy漫画所有漫画内容均获得官方正版授权，与超过100家出版社达成战略合作。我们致力于为正版漫画生态贡献力量，让每一位漫迷都能安心阅读正版内容。',
        },
      },
      {
        '@type': 'Question',
        name: 'yy漫画需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'yy漫画提供大量免费漫画内容供用户阅读。部分优质独家内容可能需要订阅会员，我们提供多种灵活的订阅方案，满足不同用户的需求。',
        },
      },
      {
        '@type': 'Question',
        name: 'yy漫画可以在手机上阅读吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '完全可以！yy漫画支持多端同步阅读，您可以在手机、平板和电脑上无缝切换，阅读进度实时同步。只需一个账号，随时随地畅享漫画。',
        },
      },
      {
        '@type': 'Question',
        name: 'yy漫画的更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'yy漫画每日更新，热门连载作品第一时间同步上架。我们的编辑团队7×24小时待命，确保读者能够第一时间阅读到最新章节。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <FeaturesSection />
        <LatestSection />
        <NewArrivals />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}